export default "__VITE_ASSET__0f6b24ce__"